var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternship(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3771 17.9999H7.62287C5.07401 17.9999 3 15.9857 3 13.5094V8.56037C3 6.08407 5.07401 4.06982 7.62287 4.06982H16.3771C18.926 4.06982 21 6.08407 21 8.56037V13.5094C21 15.9857 18.926 17.9999 16.3771 17.9999Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0466 1.36895C9.60429 1.36895 7.62437 3.36087 7.62437 5.81804V8.67002C7.62437 9.04804 7.31977 9.35449 6.94402 9.35449C6.56827 9.35449 6.26367 9.04804 6.26367 8.67002V5.81804C6.26367 2.60482 8.8528 0 12.0466 0C15.2405 0 17.8296 2.60482 17.8296 5.81804V8.67002C17.8296 9.04804 17.525 9.35449 17.1493 9.35449C16.7735 9.35449 16.4689 9.04804 16.4689 8.67002V5.81804C16.4689 3.36087 14.489 1.36895 12.0466 1.36895Z",
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.707 17.2335V12.3152H11.2436V17.2335C11.2436 17.3816 11.1235 17.5017 10.9753 17.5017C10.8271 17.5017 10.707 17.3816 10.707 17.2335Z",
    fill: "#0083FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.998 18.009V12.5676H2.99805V18.0089C2.99805 18.1428 3.04278 18.2717 3.13393 18.3661C3.54848 18.7956 4.89816 19.9999 6.99805 19.9999C9.09793 19.9999 10.4476 18.7956 10.8622 18.3661C10.9533 18.2717 10.998 18.1428 10.998 18.009Z",
    fill: "#0083FF",
    stroke: "#EEF6FE",
    strokeWidth: 0.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.71234 9.0581C6.89891 8.98063 7.10109 8.98063 7.28766 9.0581L12.6955 11.3037C13.1015 11.4723 13.1015 12.1763 12.6955 12.3449L7.28766 14.5905C7.10109 14.6679 6.89891 14.6679 6.71234 14.5905L1.30451 12.3449C0.898498 12.1763 0.898498 11.4723 1.30451 11.3037L6.71234 9.0581Z",
    fill: "#0083FF",
    stroke: "#EEF6FE",
    strokeWidth: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternship);
export default __webpack_public_path__ + "static/media/internship.722f7c10.svg";
export { ForwardRef as ReactComponent };